module.exports = __webpack_public_path__ + "img/barrier-gate.af247e3.jpg";